var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoingeckoSymbol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1011,
    viewBox: "0 0 1000 1011",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M999.995 501.717C1001.24 779.849 778.389 1006.32 502.273 1007.58C226.118 1008.84 1.25532 784.39 0.00523352 506.257C-1.24485 228.125 221.611 1.65138 497.765 0.392348C773.882 -0.828534 998.745 223.585 999.995 501.717Z",
    fill: "#FFE866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.577 323.781C717.287 313.213 679.709 298.181 641.6 283.034C639.403 273.42 630.955 261.44 613.833 246.751C588.945 225.004 542.2 225.576 501.818 235.191C457.232 224.623 413.176 220.845 370.901 231.07C25.1964 327.024 221.194 561.014 94.2539 796.301C112.323 834.873 311.615 1020.19 588.68 999.616C588.68 999.616 492.348 766.466 709.749 654.526C886.086 563.761 1013.48 395.203 753.539 323.743L753.577 323.781Z",
    fill: "#4BCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.507 233.779C525.458 246.149 636.279 285.529 685.181 300.307C629.864 220.766 556.806 223.642 494.507 233.779Z",
    fill: "#35AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.759 379.88C525.759 433.675 482.461 477.246 429.086 477.246C375.711 477.246 332.413 433.675 332.413 379.88C332.413 326.085 375.711 282.553 429.086 282.553C482.461 282.553 525.759 326.123 525.759 379.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.561 520.005C796.261 575.593 707.126 617.752 580.792 617.752C521.66 617.752 509.651 554.457 470.558 585.475C450.367 601.499 379.226 637.324 322.745 634.615C265.772 631.868 174.819 598.523 149.249 477.16C139.135 598.523 133.983 687.953 88.7148 790.431C199.838 953.745 393.589 1035 588.672 999.659C567.723 852.276 695.61 707.945 767.66 634.081C794.935 606.115 847.211 560.447 874.561 520.005Z",
    fill: "#4BCC00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.83,
    cy: 379.214,
    rx: 56.7287,
    ry: 79.4202,
    fill: "#0D1217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.833 379.205L401.759 333.822V424.588L469.833 379.205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_1338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1010.61,
    fill: "white",
    transform: "translate(0 0.38739)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoingeckoSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/coingecko-symbol.c8b38193efe81a3091bbc36f8ac13b43.svg";